module.exports = __webpack_public_path__ + "static/media/Visual_Studio_Code_1.35_icon.7539f481.svg";